import {
  BlockUI,
  NgBlockUI
} from 'ng-block-ui';
import {
  Component,
  forwardRef,
  Inject,
  Input
} from '@angular/core';

import { NgbActiveModal }           from '@ng-bootstrap/ng-bootstrap';

import { ApiService }               from '../api/api.service';
import { ChargifyPaymentInfoModel } from '../chargify/models/chargify.payment-info';
import { ChargifyService }          from '../chargify/chargify.service';
import { CodeTypeModel }            from '../core/models/code-type';
import { DateParserService }        from '../core/services/date-parser.service';
import { MessagesService }          from '../messages/messages.service';
import { RecpatchaService }         from '../recaptcha/recaptcha.service';
import { SessionService }           from '../sessions/session.service';

@Component({
  selector   : 'wor-update-subscription-payment',
  template: require('./company.update-subscription-payment.component.html')
})
export class UpdateSubscriptionPaymentComponent {
  public months : Array<number>        = this.dateParserService.getMonths();
  public states : Array<CodeTypeModel> = [];
  public years  : Array<number>        = this.dateParserService.years();

  @BlockUI('updateSubscriptionPaymentBlock') block : NgBlockUI;

  @Input() countries  : Array<CodeTypeModel>;
  @Input() paymentInfo: ChargifyPaymentInfoModel;

  constructor (
    public  activeModal      : NgbActiveModal,
    private apiService       : ApiService,
    private chargifyService  : ChargifyService,
    @Inject(forwardRef(() => DateParserService)) private dateParserService: DateParserService,
    private messagesService  : MessagesService,
    private recaptchaService : RecpatchaService,
    private sessionService   : SessionService
  ) {}

  getStates ( country = this.paymentInfo.billing_country ) : void {
    this.chargifyService.getStates(country)
    .then(( states : Array<CodeTypeModel> ) => {
      this.states = states;
    });
  }

  save () : void {
    this.block.start();

    this.recaptchaService.verifyUser()
    .then(() => this.apiService.post('/chargify/update_credit_card_details', this.paymentInfo, 'subscription'))
    .then(() => this.sessionService.refresh())
    .then(() => {
      this.activeModal.close();
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.block.stop();
    });
  };
}
